import React, { Component } from "react";

const ChangeContractDetail = ({ contracts, changeType }) => {
  return (
    <ul className="contracts-list">
      {contracts.map(c => {
        if (c.status === "UNSUCCESSFUL") {
          return (
            <li key={c.contractName} className="added">
              {c.contractName} - {c.startDate} ({c.reason})
            </li>
          );
        }
        switch (c.change) {
          case "enable":
            return (
              <li key={c.contractName} className="added">
                {c.contractName} - {c.startDate} (Added)
              </li>
            );
          case "disable":
            return (
              <li key={c.contractName} className="removed">
                {c.contractName} - {c.startDate} (Removed)
              </li>
            );
          case "modify":
            return (
              <li key={c.contractName} className="changed">
                {c.contractName} - {c.startDate} (Start date changed)
              </li>
            );
          default:
            return (
              <li key={c.contractName}>
                {c.contractName} - {c.startDate}
                {changeType === "unknown" ? null : " (Existing)"}
              </li>
            );
        }
      })}
    </ul>
  );
};

const ChangeTariffDetail = ({ planCode, changeType, startDate, changeStatus, reason }) => {
  if (changeStatus === "UNSUCCESSFUL") {
    return (
      <div className="error">
        {planCode} - {startDate} ({reason})
      </div>
    );
  }
  switch (changeType) {
    case "enable":
      return (
        <div className="added">
          {planCode} - {startDate} (Added)
        </div>
      );
    case "disable":
      return (
        <div className="removed">
          {planCode} - {startDate} (Removed)
        </div>
      );
    case "modify":
      return (
        <div className="changed">
          {planCode} - {startDate} (Start date changed)
        </div>
      );
    default:
      return planCode ? (
        <div>
          {planCode} - {startDate} (Existing)
        </div>
      ) : (
        <div>{"-"}</div>
      );
  }
};

class CustomerContractsUploadChangesDetailsTable extends Component {
  getRowHeight = idx => {
    return Math.max(60, this.props.changesList[idx].contracts.length * 19);
  };

  render() {
    let changesList = this.props.changesList;
    changesList.sort((a, b) => a.nmi - b.nmi);

    return (
      <table>
        <thead>
          <tr>
            <th>NMI</th>
            <th>Retail Plan</th>
            <th>Discount</th>
            <th>Additional Contracts</th>
          </tr>
        </thead>
        <tbody>
          {changesList.map(change => {
            return (
              <tr>
                <td>{change.nmi}</td>
                <td>
                  <ChangeTariffDetail
                    planCode={change.tariff ? change.tariff.planCode : null}
                    changeType={change.tariff ? change.tariff.change : null}
                    startDate={change.tariff ? change.tariff.startDate : null}
                    changeStatus={change.tariff ? change.tariff.status : null}
                    reason={change.tariff ? change.tariff.reason : null}
                  />
                </td>
                <td>{change.tariff ? change.tariff.discount : "-"}</td>
                <td>
                  {
                    <ChangeContractDetail
                      contracts={change.contracts}
                      changeType={this.props.changeType}
                    />
                  }
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }
}

export default CustomerContractsUploadChangesDetailsTable;
